/* eslint-disable no-console */
import * as httpService from './httpService';
import {
	setDataSources,
	setCountryList,
	setUserRoles as setAvailableUserRoles,
	setReportTypeList,
	setEmailTemplateList
} from 'spark-state/enterprise/enterpriseReducer';
import { dateRange } from 'spark-util/commonUtils';
import { setVersion, setMolecule, setReportList, setAuditReportList, setOrgTypeList } from 'spark-state/safetyLetter/safetyLetterReducer';
import { safetyLetterURL, bulkDownloadURL, ibURL, ibBulkDownloadURL, gapPacketBulkDownloadURL } from './safetyLetter/commonSafetyLetterService';
import { withEnterpriseId } from 'spark-state/stateUtil';
import { getBulkDownloadFilters } from 'spark-state/common/bulkdownload/bulkDownloadReducer';
import { toQueryParamString } from './apiUtil'; 
import { pluck } from 'spark-util/objects';
import { getIBFileContentType } from 'spark-util/fileUtils';

import axios from 'axios';



/**
 * These are the utility function used accross the appliation to fetch the common information like user info, country infor and etc.,
 */
const utilityUrl = `${process.env.SPARK_DOMAIN}/utility`;
const managementUrl = `${process.env.SPARK_DOMAIN}/safety/management`;
const configUrl = `${process.env.SPARK_DOMAIN}/config`;

export const getUserRoles = (enterpriseId) => httpService.get(`${utilityUrl}/userroles/${enterpriseId}`);

export const getCountries = (query) =>
	httpService.get(
		`${utilityUrl}/country/lov`,
		query
			? {
					queryParameters: {
						searchParam: query,
						page: 0,
						size: 25
					}
				}
			: undefined
	);

export const getCountriesForReports = (query) =>
		httpService.get(
			`${utilityUrl}/report/country/lov`,
			query
				? {
						queryParameters: {
							searchParam: query,
							page: 0,
							size: 25
						}
					}
				: undefined
		);	
/**
 * To fetch country/site roles from backend (api) 
 * Release 6.5
 * Auther: Sourabh 
 * */
export const getRoles = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(
		`${configUrl}/reporttype/cntry/roles/${enterpriseId}`,
		query
			? {
					queryParameters: {
						searchParam: query
					}
				}
			: undefined
	)
);
/**
 * To fetch global(Study) roles from backend (api) 
 * Release 6.5
 * Auther: Sourabh 
 * */
export const getGlobalRoles = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(
		`${configUrl}/reporttype/global/roles/${enterpriseId}`,
		query
			? {
					queryParameters: {
						searchParam: query
					}
				}
			: undefined
	)
);

export const getAvailableUserRoles = withEnterpriseId((enterpriseId) =>
	httpService.get(`${utilityUrl}/lov/SAFETY_MNGT_ROLES/${enterpriseId}`)
);

export const getEnterpriseSources = () => httpService.get(`${utilityUrl}/source/lov`);

export const getMappedEnterpriseList = () => httpService.get(`${utilityUrl}/listofMappedEnterprises`);

export const getReportType = withEnterpriseId((enterpriseId) =>
	httpService.get(`${utilityUrl}/reportType/${enterpriseId}`)
);

//API call for Client Reports, accepts only ENV, category and UserCategory
//SAF-17655-Mirror Country Distribution Summary Report for IB
export const getReports = withEnterpriseId((enterpriseId) => (role, category) => { 
	return httpService.get(`${utilityUrl}/getAppReportTypes/${enterpriseId}`,
	 {
	queryParameters: {
		env: `${(process.env.ENV_NAME).toUpperCase()}`,
		userCategory: role,
		category: category
	} 
	}
)
}
);

/* API call for Audit Reports - SAF-13055
	accepts ENV, UserCategory and ReportCategory*/
export const getAuditReports = withEnterpriseId((enterpriseId) => (role, rptCat) => { 
	return httpService.get(`${utilityUrl}/getAppReportTypes/${enterpriseId}`,{
	queryParameters: {
		env: `${(process.env.ENV_NAME).toUpperCase()}`,
		userCategory: role,
		category: 'Safety',
		reportCategory: rptCat
	}
	}
)
}
);

export const getSafetyLetterVersions = withEnterpriseId((enterpriseId) =>
	httpService.get(`${utilityUrl}/lov/SL_VERSION/${enterpriseId}`)
);

export const getMoleculesByEnterprise = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(`${utilityUrl}/molecule/${enterpriseId}`, {
		queryParameters: {
			searchParam: query,
			page: 0,
			size: 25
		}
	})
);

export const getProduct = withEnterpriseId((enterpriseId) => (query) =>
	// SAF-20759 Use the same API for Product dropdown as the one for product report
	// TODO: Review the API and remove the duplicate code if not required
	// httpService.get(`${utilityUrl}/product/${enterpriseId}`, {
	httpService.get(`${utilityUrl}/productReportDropDown/${enterpriseId}`, {	
		queryParameters: {
			searchParam: query,
			page: 0,
			size: 25
		}
	})
);

//SAF-18555- New API service method for product dropdown of product report -to fetch product(molecule) for product report
export const getMoleculeForProductReport = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(`${utilityUrl}/productReportDropDown/${enterpriseId}`, {
		queryParameters: {
			searchParam: query,
			page: 0,
			size: 25
		}
	})
);
export const getSafetyTitle = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(`${utilityUrl}/title/${enterpriseId}`, {
		queryParameters: {
			searchParam: query,
			page: 0,
			size: 25
		}
	})
);
// SAF-17155: Fetching the list of IB titles
// SAF-21136: isActive=Y returns active only (recipient filter)
export const getIbTitle = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(`${utilityUrl}/ibTitle/${enterpriseId}`, {
		queryParameters: {
			searchParam: query,
			page: 0,
			size: 25,
			isActive: 'Y'
		}
	})
);
/** SAF-21136: isActive omitted returns all IB titles including disabled ones (management filter) */
export const getAllIbTitles = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(`${utilityUrl}/ibTitle/${enterpriseId}`, {
		queryParameters: {
			searchParam: query,
			page: 0,
			size: 25
		}
	})
);
// SAF-15989 - get safety titles based on selected orgnization 
export const getOrgDependentSafetyTitle = withEnterpriseId((enterpriseId) => (search, orgId, orgName, siteNum) =>
	httpService.get(`${utilityUrl}/title/${enterpriseId}`, {
		queryParameters: {
			searchParam: search,
			page: 0,
			size: 25,
			orgName: orgName,
			siteNum: siteNum,
			orgMemberId: orgId
		}
	})
);
/** SAF-13059 - Service call to fetch list of all SNs for an enterprise */
export const getAllSafetyTitles = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(`${utilityUrl}/snTitles/${enterpriseId}`, {
		queryParameters: {
			searchParam: query
		}
	})
);

export const getStudy = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(`${utilityUrl}/study/${enterpriseId}`, {
		queryParameters: {
			searchParam: query,
			page: 0,
			size: 25
		}
	})
);
//SAF-17071-Add "Study of Origin" field in New Safety Notification Creation, to fetch study list based on search param and product 
export const getStudyOfOrigin = withEnterpriseId((enterpriseId) => (search, product) =>{
	const searchParam = search;
	const molecules = product.map(pluck('value'));
	const page = 0;
	const size = 25;
	return httpService.create(`${utilityUrl}/studyOriginSN/${enterpriseId}${toQueryParamString({searchParam, page, size})}`, molecules )
}
);

// SAF-15989 - get study based on selected orgnization
export const getOrgDependentStudy = withEnterpriseId((enterpriseId) => (search, orgId, orgName, siteNum) =>
	httpService.get(`${utilityUrl}/study/${enterpriseId}`, {
		queryParameters: {
			searchParam: search,
			page: 0,
			size: 25,
			orgName: orgName,
			siteNum: siteNum,
			orgMemberId: orgId
		}
	})
);
export const getSite = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(`${utilityUrl}/site/${enterpriseId}`, {
		queryParameters: {
			searchParam: query,
			page: 0,
			size: 25
		}
	})
);
// SAF-20218 - get site based on selected country for exclude site from acknowledgement in ReportType configuration page
export const getSitesForCountry = withEnterpriseId((enterpriseId) => (search, countryIso) =>
	httpService.get(`${utilityUrl}/country/sites`, {
		queryParameters: {
			countryIso: countryIso,
			entId: enterpriseId,
			searchText: search
		}
	})
);

export const getEmailTemplates = withEnterpriseId((enterpriseId) =>(safetyId)=>
	httpService.get(`${utilityUrl}/emailTemplate/${enterpriseId}`,{ queryParameters: {
		category: 'safety',
		documentId: safetyId
	}})
);
//SAF-17733 Fetching IBEmailTemplates for manual Notify
export const getIBEmailTemplates = withEnterpriseId((enterpriseId) =>(safetyId)=>
	httpService.get(`${utilityUrl}/emailTemplate/${enterpriseId}`,{ queryParameters: {
		category: 'ib',
		documentId: safetyId
	}})
);

//TODO: If more document services are created, consider creating a documentService
export const downloadManagerGlobalDoc = (safetyId, title, type) =>
	httpService.download(`${managementUrl}/download/${safetyId}`, null, {
		title,
		type
	});

//API call for downloading Global IB document
export const downloadManagerIBGlobalDoc = (safetyId, title, type) =>
	httpService.download(`${ibURL}/management/download/${safetyId}`, null, {
		title,
		type
	});

export const downloadCountryLevelDoc = (safetyId, countryIso, title, type) =>
	httpService.download(`${managementUrl}/download/country/${safetyId}/${countryIso}`, null, {
		title,
		type
	});

export const downloadCountryLevelDocForIB = (safetyId, countryIso, title, type) =>
	httpService.download(`${ibURL}/management/download/country/${safetyId}/${countryIso}`, null, {
		title,
		type
	});
	
/**
 * accessIBStudyFile function to view or download IB study-specific documents for Management Users
 * @param {*} safetyId - Safety ID
 * @param {*} countryIso - Country ISO code
 * @param {*} studyFileRef - Study file reference (contains safetyCountryStudyId_fileName)
 * @param {*} isManagementUser - is the user a management user
 * @param {*} action - Action type: 'VIEW_IB_STUDY_DOC' or 'DOWNLOAD_IB_STUDY_DOC'
 * @param {*} fileType - File type for content-type
 */
export const accessIBStudyFile = withEnterpriseId((enterpriseId) => (safetyId, countryIso, studyFileRef, isManagementUser, action, fileType) => {
	const fileName = studyFileRef;
	const managementUserFlag = (isManagementUser === true || isManagementUser === "Y") ? "Y" : "N";
	return httpService.postDownloadForIBStudyDocument(`${utilityUrl}/ib/access/ibstudyfile/${safetyId}/${countryIso}`, {
		"entId": enterpriseId,
		"fileName": fileName,
		"isManagementUser": managementUserFlag,
		"action": action
	}, {type: getIBFileContentType(fileType)});
});
/**
 * SAF-19168 accessIBRecipientStudyFile function to view or download IB study-specific documents For Recipient User
 * @param {*} safetyId - Safety ID
 * @param {*} studyFileRef - Study file reference (contains safetyCountryStudyId_fileName)
 * @param {*} isManagementUser - is the user a management user
 * @param {*} action - Action type: 'VIEW_IB_STUDY_DOC' or 'DOWNLOAD_IB_STUDY_DOC'
 * @param {*} fileType - File type for content-type
 */
export const accessIBRecipientStudyFile = withEnterpriseId((enterpriseId) => (safetyId, studyFileRef, isManagementUser, action, fileType) => {
	const fileName = studyFileRef;
	const managementUserFlag = (isManagementUser === true || isManagementUser === "Y") ? "Y" : "N";
	return httpService.postDownloadForIBStudyDocument(`${utilityUrl}/ib/access/ibstudyfile/${safetyId}`, {
		"entId": enterpriseId,
		"fileName": fileName,
		"isManagementUser": managementUserFlag,
		"action": action
	}, {type: getIBFileContentType(fileType)});
});
export const downloadRecipientDoc = (safetyId, title, type) =>
	httpService.download(`${safetyLetterURL}/recipient/download/${safetyId}`, null, {
		title,
		type
	});
//SAF-17166 - download single IB document
export const ibDownloadRecipientDoc = (safetyId, title, type) =>
	httpService.download(`${ibURL}/recipient/download/${safetyId}`, null, {
		title,
		type
	});
export const downloadBulkDoc = (entId,data,date, type) =>
	httpService.postDownload(`${bulkDownloadURL}/zipFile/${entId}`, JSON.stringify({listofSlId: data}), date, {
		type
	});

export const downloadBulkDocRecipient = (entId,data,type) =>
	httpService.postDownloadRecipient(`${bulkDownloadURL}/recipient/zipFile/${entId}`, JSON.stringify({listofSlId: data}), {
		type
	});	
//SAF-17166 - bulk download IB documents
export const ibDownloadBulkDocRecipient = (entId,data,type) =>
	httpService.postDownloadRecipient(`${ibBulkDownloadURL}/bulkdownload/recipient/zipFile/${entId}`, JSON.stringify({listofSlId: data}), {
		type
	});	

const bulkDownloadFormVals = (enterpriseId,query,getState, parameters) => {
	query = {...query,...getBulkDownloadFilters(getState())}

	let page = (query && query.page) || 0;
    let size = (query && query.size) || 10;	
        return httpService.create(
            `${bulkDownloadURL}/listofNotifications/${enterpriseId}${toQueryParamString({page,
                size,})}` , 
			
			JSON.stringify({
				startDate: (query.dateRange && dateRange((query.dateRange).start)) || '',
				endDate: (query.dateRange && dateRange((query.dateRange).end)) || '',
				studyIds: (query && query.study && [query.study.idValue]) || [],
				recipientEmail: (query && query.emailRecipient) || '',
				molecules: (query && query.product && [query.product.value]) || [],
				reportTypes: (query && query.reportType && [query.reportType]) || [],
				country: (query && query.country && [query.country.value])  || [],
				
			}),
			{ type: 'application/json'
		}
		);
}
	
export const getSafetyNotificationsforBulkDownload = withEnterpriseId(enterpriseId => query => (dispatch, getState)=>dispatch(bulkDownloadFormVals(enterpriseId, query, getState)))
const bulkDownloadFormValsForCreateGapPacket = (enterpriseId,query,getState, parameters) => {
	query = {...query,...getBulkDownloadFilters(getState())}
	let page = (query && query.page) || 0;
	let size = (query && query.size && (query.size === 10 ? 50 : query.size)) || 50;	
	return httpService.create(
		`${bulkDownloadURL}/listofNotifications/${enterpriseId}${toQueryParamString({page, size,})}`, 
		JSON.stringify({
				startDate: (query.dateRange && dateRange((query.dateRange).start)) || '',
				endDate: (query.dateRange && dateRange((query.dateRange).end)) || '',
				studyIds: (query && query.study && [query.study.idValue]) || [],
				recipientEmail: (query && query.emailRecipient) || '',
				molecules: (query && query.product && [query.product.value]) || [],
				reportTypes: (query && query.reportType && [query.reportType]) || [],
				country: (query && query.country && [query.country.value])  || [],
				
			}),
		{ type: 'application/json' }
	);
}
export const getSafetyNotificationsforCreateGapPacket = withEnterpriseId(enterpriseId => query => (dispatch, getState)=>dispatch(bulkDownloadFormValsForCreateGapPacket(enterpriseId, query, getState)))
export const bulkDownloadFailed = (enterpriseId, listofSlId, parameters = {}) =>
	httpService.create(`${bulkDownloadURL}/event/${enterpriseId}`, {
		listofSlId,
		eventType: 'BK_DOWNLOAD_FAILED',
		...parameters
		}	);

export const bulkDownloadFailedRecipient = (enterpriseId, listofSlId, parameters = {}) =>
httpService.create(`${bulkDownloadURL}/recipient/event/${enterpriseId}`, {
	listofSlId,
	eventType: 'BK_DOWNLOAD_FAILED',
	...parameters
	}	);		

//SAF-17166 - record failur event for bulk download IB docs
export const ibBulkDownloadFailedRecipient = (enterpriseId, listofSlId, parameters = {}) =>
	httpService.create(`${ibBulkDownloadURL}/recipient/event/${enterpriseId}`, {
		listofSlId,
		eventType: 'IB_BK_DOWNLOAD_FAILED',
		...parameters
		}	);		
/**
 * Calling these functions "loaders" since they do more than get a server resource.
 *
 * Note: Generally, we don't want to define what to do with the response in the same
 * file as the service method itself. However, these utility methods are not likely
 * to be used outside of this predefined context, so an exception can be made. If
 * this assumption proves incorrect, then we get rid of these loaders.
 */
const loadLOVIntoState = (getter, setter) => (...args) => async (dispatch) => {
	let response = await dispatch(getter(...args));
	dispatch(setter(response));
};

// get list of available Org Types - SAF-15597-Role Management: Ability to add new role from the application
export const getOrgType = () =>{
	return httpService.get(`${utilityUrl}/orgType`);
};

export const loaders = {
	countries: loadLOVIntoState(getCountries, setCountryList),
	availableUserRoles: loadLOVIntoState(getAvailableUserRoles, setAvailableUserRoles),
	enterpriseSources: loadLOVIntoState(getEnterpriseSources, setDataSources),
	reportTypes: loadLOVIntoState(getReportType, setReportTypeList),
	reports: loadLOVIntoState(getReports, setReportList),
	safetyLetterVersions: loadLOVIntoState(getSafetyLetterVersions, setVersion),
	molecules: loadLOVIntoState(getMoleculesByEnterprise, setMolecule),
	emailTemplates: loadLOVIntoState(getEmailTemplates, setEmailTemplateList),
	ibEmailTemplates: loadLOVIntoState(getIBEmailTemplates, setEmailTemplateList), // SAF-17733 loading ibEmailTemplates in state
	//Audit Reports
	auditReports: loadLOVIntoState(getAuditReports, setAuditReportList),
	orgTypeList: loadLOVIntoState(getOrgType, setOrgTypeList),

};

export const trackUser = (enterpriseId) => httpService.create(`${utilityUrl}/trackUser/${enterpriseId}`); // passing entId parameter to trackuser API as pat of 6.4 release

export const recipientDownloadFailed = (safetyId, parameters = {}) =>
	httpService.create(`${safetyLetterURL}/recipient/event/${safetyId}`, {
		safetyId,
		eventType: 'DOWNLOAD_FAILED',
		...parameters
	});

//SAF-17166 - record failur event for download single IB document	
export const ibRecipientDownloadFailed = (safetyId, parameters = {}) =>
	httpService.create(`${ibURL}/recipient/event/${safetyId}`, {
		safetyId,
		eventType: 'IB_DOWNLOAD_FAILED',
		...parameters
	});

	export const getSelectedEnterprise = withEnterpriseId(entId =>
		 entId
	);
//SAF-14083: to fetch ack status filter options for overdue Ack form
export const getAckStatus = withEnterpriseId((enterpriseId) =>
	httpService.get(`${utilityUrl}/lov/CLOSED WITHOUT ACK/${enterpriseId}`)
);
//SAF-18323-Gap Packet Issues- To fix download events
export const downloadGapPacketSets= (enterpriseId, safetyIds, setNumber, gpTitle, type) => {
	return httpService.postDownloadForGPSet(`${gapPacketBulkDownloadURL}/downloadZip/${enterpriseId}`, JSON.stringify({subGapPaketId: safetyIds, isMngtUser: "Y"}), {
		type,
		setNumber,
		gpTitle
	})
}
//SAF-18323-Gap Packet Issues- To fix download events
export const downloadGapPacketSetsForRecipient= (enterpriseId, safetyIds, setNumber, gpTitle, type) => {
	return httpService.postDownloadForRecipientGPSet(`${gapPacketBulkDownloadURL}/downloadZip/${enterpriseId}`, JSON.stringify({subGapPaketId: safetyIds, isMngtUser: "N"}), {
		type,
		setNumber,
		gpTitle
	})
}
export const downloadGapPacketSnFiles = (entId,data,date, type) =>
	httpService.postDownloadForGapPacket(`${bulkDownloadURL}/zipFile/${entId}`, JSON.stringify({listofSlId: data}), date, {
		type
	});

// SAF-18351 API call for getting file details for inline viewer
// same API is used for 1. Safety letter and IB, 2. Global and country level, 3. Management and recipient users
export const viewDoc = (safetyId, fileName, enterpriseId, isManagementUser, category, countryIso=null) =>
	httpService.viewDocument(`${utilityUrl}/docViewer/${enterpriseId}`, {
		slid: safetyId,
		fileName: fileName,
		isManagementUser: isManagementUser,
		category: category,
		countryIso: countryIso //SAF-18488 - added countryIso to the API call
	});
// SAF-18752 Get list of email languages based on enterpriseId
export const getEmailLanguages = withEnterpriseId((enterpriseId) =>
	httpService.get(`${utilityUrl}/lov/NOTIFI_LANG/${enterpriseId}`)
);

// To fetch current Application Version - SAF-19125-Safety - Displaying the Version Number
// Use text: semver values like 8.0.1 are not valid JSON numbers, so default json parsing can break the response.
export const getVersion = () =>
	httpService.get(`${utilityUrl}/getVersion`, {
		responseType: 'text',
		transformResponse: [(data) => data]
	});



const selectKcToken = (state) =>
  (state && state.app && state.app.kcToken) || null;

/**
 * Fetches the WAT from Analytics service (GET, plain text).
 * Returns a CLEAN string token (whitespace removed) or throws.
 */
export const getWebAccessToken = () => async (_dispatch, getState) => {
  const authToken = selectKcToken(getState());
  console.log('[WAT API] KC token exists?', !!authToken, 'len:', authToken ? String(authToken).length : 0);

  if (!authToken) {
    throw new Error('Missing Keycloak token');
  }

  const watUrl = `${process.env.ANALYTICS_WAT_TOKEN_URL}`;
  let resp;
  try {
    resp = await axios.get(
		watUrl,
      {
        // This is crucial for plain text responses:
        responseType: 'text',
        transformResponse: [(data) => data], // keep raw body as-is (string)
        headers: {
          // The service might return text/plain; don't force JSON here
          'Content-Type': 'application/json',
          Accept: '*/*',
          Authorization: `Bearer ${authToken}`,
        },
        // Accept 201 Created too
        validateStatus: (status) => status >= 200 && status < 400,
      }
    );
  } catch (e) {
	console.log('[WAT] ANALYTICS_WAT_TOKEN_URL:', process.env.ANALYTICS_WAT_TOKEN_URL);
	console.log('[WAT] ANALYTICS_WAT_TOKEN_URL_PM:', `${process.env.ANALYTICS_WAT_TOKEN_URL}`);
	
    console.error('[WAT API] axios error:', (e && e.message) || e);
    throw e;
  }

  // 1) If body is a string, use it
  let token = (resp && typeof resp.data === 'string' && resp.data.trim().length > 0)
    ? resp.data
    : null;

  // 2) Fallback: some services put token in headers (rare)
  if (!token && resp && resp.headers) {
    token =
      resp.headers['x-wat-token'] ||
      resp.headers['x-web-access-token'] ||
      resp.headers['x-access-token'] ||
      resp.headers['authorization'] ||
      null;

    // or in Location header (if 201)
    if (!token && resp.headers.location) {
      const loc = resp.headers.location;
      const matchPath = loc.match(/\/wat\/([^/?#]+)/i);
      const matchQuery = loc.match(/[?&]token=([^&]+)/i);
      token = (matchPath && matchPath[1]) || (matchQuery && matchQuery[1]) || null;
    }
  }

  if (!token) {
    throw new Error('WAT response did not contain a token in body or headers.');
  }

  // Normalize: remove whitespace/newlines/tabs just in case
  token = String(token).replace(/\s+/g, '');
  return token;
};

/**
 * SAF-18432-Safety - User Guide Integration
 * Get list of user guides
 * @returns {Promise} - Promise resolving to the list of user guides
 */
export const getUserGuides = () => httpService.get(`${utilityUrl}/gitlab/userGuides`);

/**
 * SAF-18432-Safety - User Guide Integration
 * View a specific user guide by ID - returns file content (base64/json)
 * @param {string} id - User guide ID
 */
export const viewUserGuide = (id) => httpService.getUserGuideForView(`${utilityUrl}/gitlab/userGuides/${id}`);

/**
 * SAF-18432-Safety - User Guide Integration
 * Download a specific user guide by ID
 * @param {string} id - User guide ID
 * @param {string} fileName - Name of the file to be downloaded (used for setting the download file name in browser)
 */
export const downloadUserGuide = (id, fileName) => httpService.getUserGuideForDownload(`${utilityUrl}/gitlab/userGuides/${id}/download`, fileName);
